import {eventMiddlewareForFE as eventMiddlewareForFEFromCore} from '@ibibo/event-middleware-for-fe';
import {nonNullable} from '../../types/type-guards';

export const singletonFactory = (() => {
  let obj: Record<string, any> = {};

  function getObject(name: string) {
    if (obj[name]) return obj[name];
    obj[name] = {};
    return obj[name];
  }

  return {
    getObject,
  };
})();

export const getUrlParams = (url: string) =>
  `${url}?`
    .split('?')[1]
    .split('&')
    .reduce(
      (params, pair) =>
        ((key, val) => (key ? {...params, [key]: val} : params))(
          ...`${pair}=`.split('=').map(decodeURIComponent),
        ),
      {},
    );

// ! add generic types to util
export const isObjectEmpty = obj => {
  return !(obj && Object.keys(obj).length > 0);
};

export function eventMiddlewareForHotelsDwebFE(args) {
  args.eventObj.eventCategory = 'HotelsDwebFEGenericTracking';
  return eventMiddlewareForFEFromCore(args);
}

export function eventMiddlewareForFE(args) {
  args.eventCategory = 'HotelsDwebFEGenericTracking';
  return eventMiddlewareForFEFromCore(args);
}

export function gaFilterListShortName(srpConfig) {
  const {filter = {}, s: sortFn = ''} = srpConfig;

  let listName = 'D';

  const {tag = '', ...otherFilters} = filter;
  if (tag && tag.length > 0) {
    listName += `_${tag.split('')[0]}`;
  } else {
    listName += '_H';
  }

  switch (sortFn) {
    case 'popularity':
      listName += '_Po';
      break;

    case 'pricedown':
    case 'priceup':
      listName += '_Pr';
      break;

    case 'rating':
      listName += '_R';
      break;

    case 'nearby':
      listName += '_Ne';
      break;

    default:
      listName += '_Po';
  }

  let applied = 0;
  Object.keys(otherFilters).forEach(fltkey => {
    const flt = otherFilters[fltkey];
    if (Array.isArray(flt) && flt.length > 0) {
      applied += 1;
    } else if (typeof flt === 'string' && flt.length) {
      applied += 1;
    } else if (typeof flt === 'number' && flt > 0) {
      applied += 1;
    }
  });

  if (applied > 0) {
    listName += '_F_<';
  }

  const {range, star, location_search, type, amenities, fc, rnpl, pah, gobiz, cf} = otherFilters;
  if (amenities && amenities.length) {
    listName += 'A,';
  }
  if (fc) {
    listName += 'FC,';
  }
  if (location_search && location_search.length) {
    listName += 'L,';
  }
  if (range && range.length) {
    listName += 'P,';
  }
  if (star && star.length) {
    listName += 'S,';
  }
  if (type && type.length) {
    listName += 'T,';
  }
  if (cf) {
    listName += 'CF,';
  }
  if (rnpl) {
    listName += 'RN,';
  }
  if (pah) {
    listName += 'PAH,';
  }
  if (gobiz) {
    listName += 'BIZ,';
  }

  if (listName.charAt(listName.length - 1) === ',') {
    listName = listName.slice(0, -1);
  }

  if (applied > 0) {
    listName += '>';
  }

  return listName;
}

export function get_queryParameters(key, url) {
  const result = new RegExp(`(?:\\?|\\&)${encodeURIComponent(key)}=([^\\&\\#]*)`).exec(url);
  return result && result.length ? result[1] : null;
}

// https://stackoverflow.com/questions/5497318/replace-last-occurrence-of-character-in-string
export const replaceLastHyphenWithUnderScore = (s: string) => s.replace(/-([^-]*)$/, '_' + '$1');

export const allFirstLevelObjectKeysAreNonNullable = (object: object) => {
  return Object.keys(object).every(key => nonNullable(object[key]));
};

// 🐨 type this properly
export const queryBuilder = queryParams => {
  return Object.entries(queryParams).reduce((accumulatedString, queryNameAndVal, index) => {
    const queryName = queryNameAndVal[0];
    const queryVal = queryNameAndVal[1];

    if (!queryVal) return accumulatedString;

    const queryStructure = `${queryName}=${queryVal}`;
    return index === 0
      ? `${accumulatedString}?${queryStructure}`
      : `${accumulatedString}&${queryStructure}`;
  }, '');
};

export const searchWidgetId = 'search-widget';

export const removeItemFromArray = (item, arr) => {
  const indexOfItem = arr.indexOf(item);
  return [...arr.slice(0, indexOfItem), ...arr.slice(indexOfItem + 1)];
};
